export default __webpack_public_path__ + "static/media/dot-arrow.71cea845.svg";